var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"w-full"},[_c('SlideMenuGen'),_c('CardsGen'),_c('ServicesClinic'),_c('SpecialistClinic'),_c('ReviewsClinic'),_c('social-network',{attrs:{"messengers":_vm.messenger}}),_c('video-clinic',{attrs:{"video":_vm.video}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }